//'use strict';
niacs.filters = angular.module('NiacsProjectApp.filters',[
])
// this directive is in "filters" because fitlers is used by all apps and fa-icon is needed by all apps
.directive('faIcon',[function() {
    return {
      restrict: 'E',
      template: '',
      scope: {
        faPrefix: '@',
        icon: '@',
        classes: '@'
      },
      link: function($scope,$element) {
        $scope.$watch('icon',function(icon) {
          $element.html('<i class="'+($scope.faPrefix||niacs.FA_PREFIX)+' fa-'+icon+' '+($scope.classes||'')+'"></i>');
        });
      }
    };
  }])
.filter('niacsResourceReference',['$sce',function($sce){
    return function(input) {
        var html = "",i;
        if(input.author && input.author.length) {
            html += input.author[0];
            if(input.author.length > 1) {
                html += (input.author.length === 2 ? " and " : ", ") + input.author[1];
            }
            html += (input.author.length > 2) ? ", and others." : ".";
        }
        if(input.date) {
            html += ' '+input.date+'.';
        }
        for(i = 0; input.link && i < input.link.length; i++) {
            html += ' '+input.link[i].title;
            html += '.';
        }
        for(i = 0; input.attachment && i < input.attachment.length; i++) {
            html += ' '+(input.attachment[i].description||input.attachment[i].filename);
            html += '.';
        }
        if(input.source && input.volume && input.pages) {
            html += ' '+input.source+', '+input.volume+':'+input.pages+'.';
        }
        for(i = 0; input.link && i < input.link.length; i++) {
            html += ' '+input.link[i].url;
            html += '.';
        }
        for(i = 0; input.attachment && i < input.attachment.length; i++) {
            html += ' '+input.attachment[i].self;
            html += '.';
        }
        return $sce.trustAsHtml(html);
    };
}])
.filter('niacsResourceDisplay',['$sce',function($sce){
    return function(input,noIcons,justAttribution) {
        var html = "",i;
        if(input.author && input.author.length) {
            html += input.author[0];
            if(input.author.length > 1) {
                html += (input.author.length === 2 ? " and " : ", ") + input.author[1];
            }
            html += (input.author.length > 2) ? ", and others." : ".";
        }
        if(input.date) {
            html += ' '+input.date+'.';
        }
        if(!justAttribution) {
            for(i = 0; input.link && i < input.link.length; i++) {
                html += ' <a href="'+input.link[i].url+'" target="_blank">';
                if(!noIcons) {
                    html += '<i class="'+niacs.FA_PREFIX+' fa-link"></i> ';
                }
                html += input.link[i].title;
                html += '</a>.';
            }
            for(i = 0; input.attachment && i < input.attachment.length; i++) {
                html += ' <a href="'+input.attachment[i].self+'" target="_blank">';
                if(!noIcons) {
                    html += '<i class="'+niacs.FA_PREFIX+' fa-file-pdf"></i> ';
                }
                html += input.attachment[i].description||input.attachment[i].filename;
                html += '</a>.';
            }
        }
        if(input.source) {
            html += ' '+input.source+'.';
        }
        return $sce.trustAsHtml(html);
    };
}])
/**
 * Given a term id and vocabulary returns the term.
 * If not found returns the input id.
 */
.filter('niacsTerm',function(){
    return function(input,vocab,defaultValue){
        if(vocab) {
            for(var i = 0; i < vocab.length; i++) {
                if(vocab[i].id == input) {
                    return vocab[i].label;
                }
            }
        }
        return arguments.length > 2 ? arguments[2] : (defaultValue||"<Not Set>");
    };
})
/**
 * This filter sifts a list of objects and picks out the
 * pre-defined or user-defined from the over-all list.  This
 * way things like units and cistatements can reside in the same
 * list simplifying the over-all datastructures.
 * server side (pre-defined) objects have integer ids while
 * user-defined objects have string ids.
 */
.filter('preFromUser',function(){
    return function(list,type) {
        if(!type) {
            type = 'predefined';
        }
        if(list){
            var filtered = [],
                filter = type == 'predefined' ? angular.isNumber : angular.isString;
            angular.forEach(list,function(item){
                if(filter(item.id)) {
                    filtered.push(item);
                }
            });
            return filtered;
        }
        return list;
    };
})
/**
 * Takes a list of objects/references which consist of an id,
 * possibly some extra attributes, and "inflates" them.
 * All values from server side objects will be stored on the object
 * itself prefixed with $ so they are not shipped to the server on save.
 *
 * By default this filter will only inflate references to server side data
 * where the id in question is numeric.  An additional boolean argument (set to
 * true) can be supplied to cause the filter to search the "serverList" regardless
 * of the type of id in question (i.e. references to other project specific entities).
 *
 * input
 * [{id:'xxxx-yyyy',foo:'custom'},{id:2}],[{id:1,foo:'bar'},{id:2,foo:'blah'}]
 * output:
 * [{id:'xxxx-yyyy',foo:'custom'},{id:2,$foo:'blah'}]
 */
.filter('inflate',function() {
    return function(list,serverList,allIds) {
        if(list && serverList) {
            angular.forEach(list,function(item){
                if(item) {
                    var i,key,pkey;
                    if(item && (allIds || angular.isNumber(item.id))) {
                        for(i = 0; i < serverList.length; i++) {
                            if(serverList[i] && item.id == serverList[i].id) {
                                for(key in serverList[i]) {
                                    if(key == '$$hashKey') {
                                        continue; // seems like a good idea to not copy this one.
                                    }
                                    pkey = key.substring(0,1) == '$' ? key : '$'+key;
                                    item[pkey] = serverList[i][key];
                                }
                                break;
                            }
                        }
                    }
                }
            });
        }
        return list;
    };
})
/**
 * Used for "removed from list" kinds of display purposes.
 * input is the list to filter and inuse is the "list".  The result
 * will be input minus what's on the list.
 */
.filter('inUse',function(){
    return function(input,inuse) {
        if(input && inuse && input.length && inuse.length) {
            var filtered = [],
                i,j,found;
            for(i = 0; i < input.length; i++) {
                if(!input[i]) {
                    continue;
                }
                found = false;
                for(j = 0; j < inuse.length; j++) {
                    if(!inuse[j]) {
                        continue;
                    }
                    if(found=(input[i].id == inuse[j].id)) {
                        break;
                    }
                }
                if(!found) {
                    filtered.push(input[i]);
                }
            }
            return filtered;
        }
        return input;
    };
})
/**
 * Given a timestamp return a readable string stating
 * the number of days/months/years from the timestamp until
 * this moment.
 */
.filter('timestampReadableSince',function(){
    return function(timestamp){
        var diff = (new Date()).getTime()-timestamp,
            days;
        if(diff <= 0) {
            return timestamp;
        }
        days = Math.ceil((diff/1000)/60/60/24);
        if(days > 365) {
            return Math.floor(days/365) + " years";
        } else if(days > 30) {
            return Math.floor(days/30) + " months";
        }
        return days + " days";
    };
})
/**
 * Simply returns a string indicating that the input is
 * "empty" for display purposes.
 */
.filter('mightBeEmpty',function(){
    return function(val) {
        return val  ? val :
        arguments.length > 1 ? arguments[1] : '<Empty>';
    };
})
/**
 * Given an object (project or unit) that has goals
 * count the # of goals and objectives and return a
 * formatted string representation.
 */
.filter('goalObjectiveCount',function(){
    function countGoals(hasGoals) {
        return hasGoals && hasGoals.goals ? hasGoals.goals.length : 0;
    }
    function countObjectives(hasGoals) {
        var objectiveCnt = 0;
        if(hasGoals && hasGoals.goals) {
            angular.forEach(hasGoals.goals,function(goal){
                if(goal.objectives) {
                    objectiveCnt += goal.objectives.length;
                }
            });
        }
        return objectiveCnt;
    }
    return function(hasGoals,nested) {
        var goalCnt = 0, objectiveCnt = 0,output;
        if(hasGoals) {
            // since top level project goals no longer hold objectives
            // pick what to count based on 'nested'
            // i.e. !nested just hasGoals else hasGoals.units
            if(!nested) {
                goalCnt += countGoals(hasGoals);
                objectiveCnt += countObjectives(hasGoals);
            } else if (hasGoals.units) {
                angular.forEach(hasGoals.units,function(unit){
                    goalCnt += countGoals(unit);
                    objectiveCnt += countObjectives(unit);
                });
            }
        }
        output = goalCnt+' Goals';
        // hack to test if hasGoals is a project or unit
        if(hasGoals && !hasGoals.$vuln_region) {
            output += ' | '+objectiveCnt+' Objectives';
        }
        return output;
    };
}).
filter('adaptiveCapacity',function(){
    return function(input) {
        if(typeof(input) == 'undefined') {
            return 'not set';
        }
        if(angular.isNumber(input)){
            if(input >= 0 && input <= 20) {
                return 'Low';
            } else if(input > 20 && input <= 40) {
                return 'Low-Moderate';
            } else if(input > 40 && input <= 60) {
                return "Moderate";
            } else if(input > 60 && input <= 80) {
                return "Moderate-High";
            } else if (input > 80 && input <= 100) {
                return 'High';
            }
        }
        return input;
    };
})
.filter('potentialImpacts',function(){
    return function(input) {
        if(typeof(input) == 'undefined') {
            return 'not set';
        }
        if(angular.isNumber(input)){
            if(input >= 0 && input <= 20) {
                return 'Very supportive to ecosystem';
            } else if(input > 20 && input <= 40) {
                return 'Supportive';
            } else if(input > 40 && input <= 60) {
                return "Mixed/Neutral";
            } else if(input > 60 && input <= 80) {
                return "Disruptive";
            } else if (input > 80 && input <= 100) {
                return 'Very disruptive to ecosystem';
            }
        }
        return input;
    };
})
.filter('tacticPracticability',['$filter','$sce',function($filter,$sce){
    return function(practicability,vocab) {
        var resolved = $filter('niacsTerm')(practicability,vocab,'-'),
            clazz = resolved === '-' ? 'not_set' : resolved.toLowerCase().replace(/ /g, '_');
        if(resolved === '-') {
            resolved = '&lt;Not Set&gt;';
        }
        return $sce.trustAsHtml("<span class='practicability "+clazz+"'>"+resolved+'</span>');
    };
}])
.filter('vulnerabilityDetermination',['$filter','$sce',function($filter,$sce){
    return function(vd,vocab) {
        var resolved = 'not determined',
            r2;
        if(vocab) {
            r2 = $filter('niacsTerm')(vd,vocab);
            // this is fragile.
            if(r2 != '<Not Set>') {
                resolved = r2;
            }
        }
        return $sce.trustAsHtml("<span class='vulnerability "+resolved.toLowerCase().replace(/ /g, '_')+"'>"+resolved+'</span>');
    };
}])
.filter('yesNo',function(){
    return function(input){
        if(input === true) {
            return "Yes";
        }
        return "No";
    };
})
.filter('ellipses',function(){
    return function(input) {
        var maxLen = arguments.length == 2 ? arguments[1] : 55;
        if(typeof(input) == 'string' && input.length > maxLen) {
            return input.substring(0,maxLen)+" ...";
        }
        return input;
    };
})
.filter('unitLabel',function(){
    return function(unit,project,regional) {
        if(!unit || !project) {
            return '?';
        }
        return project.id === unit.id ? (regional ? 'Regional': 'Property-wide') : (unit.label||unit.$label);
    };
})
.filter('stepLabel',function() {
    var flatMenu = niacs.flattenMenu();
    return function(view) {
        for(var i = 0; i < flatMenu.length; i++) {
            if(flatMenu[i].item === view) {
                return flatMenu[i].label;
            }
        }
        return view;
    };
})
.filter('tacticRecommendationBanner',function(){
    function counts(goal) {
        var nm = [0,0],i,j;
        if(goal && goal.objectives) {
            for(i = 0; i < goal.objectives.length; i++){
                if(goal.objectives[i].tactics) {
                    nm[1] += goal.objectives[i].tactics.length;
                    for(j = 0; j < goal.objectives[i].tactics.length; j++) {
                        if(goal.objectives[i].tactics[j].recommended) {
                            nm[0] += 1;
                        }
                    }
                }
            }
        }
        return nm;
    }
    return function(context) {
        var n = 0, m = 0,nm,i;
        if(context && context.goals) {
            for(i = 0; i < context.goals.length; i++ ) {
                nm = counts(context.goals[i]);
                n += nm[0];
                m += nm[1];
            }
        }
        return n + " of " + m + ' tactics recommended';
    };
})
.filter('countObjectives',function() {
    return niacs.countObjectives;
})
.filter('countClimateImpacts',function(){
    return niacs.countClimateImpacts;
})
.filter('countVulnerabilityDeterminations',function(){
    return function(project) {
        var count = 0,i;
        if(project) {
            //if(project.vulnerability) count++; // not determining project vulnerability
            if(project.units) {
                for(i = 0; i< project.units.length; i++) {
                    if(project.units[i].vulnerability) { count++; }
                }
            }
        }
        return count;
    };
})
.filter('objectiveEvaluateObjectCompleteness',function(){
    return function(objective,asText) {
        var status = niacs.testObjectCompleteness(objective.evaluate,['challenges','opportunities','feasibility','feasibility_comments','considerations']);
        if(asText) {
            return (status == niacs.COMPLETE ? "All" :
                status == niacs.PARTIAL_COMPLETE ? "Some" : "No") + " evaluation details supplied";
        } else if (status == niacs.PARTIAL_COMPLETE) {
            status = niacs.COMPLETE; // originally gave different indicators but....
        }
        return status;
    };
})
.filter('objectEvaluateBanner',function(){
    return function(context,includeUnits) {
        var objectives = niacs.collectObjectives(context,includeUnits);
        return objectives.reduce(
            function(count,objective,i,a){
                return !niacs.isEmptyObject(objective.evaluate) ? (count+1) : count;
        },0) +
        ' of ' + objectives.length + ' objectives evaluated';
    };
})
.filter('objectMonitorBanner',function(){
    return function(context,includeUnits) {
        var objectives = niacs.collectObjectives(context,includeUnits);
        return objectives.reduce(
            function(count,objective,i,a){
                return (objective.monitor && objective.monitor.length > 0) ? (count+1) : count;
        },0) +
        ' of ' + objectives.length + ' objectives have monitoring variables';
    };
})
.filter('step1Completeness',function(){
    return function(project,part /* a|b|ab */) {
        if(!project || !part) {
            return niacs.INCOMPLETE;
        }
        var ta = part === 'a' || part === 'ab',
            tb = part === 'b' || part === 'ab',
            a = niacs.INCOMPLETE,
            b = niacs.INCOMPLETE;
        if(ta) {
            a = project.units && project.units.length ? niacs.COMPLETE : niacs.INCOMPLETE;
        }
        if(tb) {
            b = project.units && project.units.length ?
                niacs.testCompleteness(
                    project.units.map(function(e,i,a){
                        if(!e.goals || e.goals.length === 0) {
                            return niacs.INCOMPLETE;
                        }
                        return niacs.testCompleteness(
                            e.goals.map(function(e2,i2,a2){
                                return e2.objectives && e2.objectives.length ? niacs.COMPLETE : niacs.INCOMPLETE;
                            })
                        );
                    })) : niacs.INCOMPLETE;
        }
        return (ta&&tb) ? niacs.testCompleteness([a,b]) :
                ta ? a : b;
    };
})
.filter('step2Completeness',function(){
    return function(project,part /* a|b|ab */) {
        if(!project || !part) {
            return niacs.INCOMPLETE;
        }
        var units = project && project.units ? [project].concat(project.units) : [project],
            ta = part === 'a' || part === 'ab',
            tb = part === 'b' || part === 'ab',
            a = niacs.INCOMPLETE,
            b = niacs.INCOMPLETE;
        if(ta) {
            a = niacs.testCompleteness(
                units.map(function(e,i,a){
                    return e.cistatements && e.cistatements.length ? niacs.COMPLETE : niacs.INCOMPLETE;
                }));
        }
        if(tb) {
            b = niacs.testCompleteness(
                units.slice(1).map(function(e,i,a){ // not determining vulnerability on project so dropping it from the list here.
                    return e.vulnerability ? niacs.COMPLETE : niacs.INCOMPLETE;
                }));
        }
        return (ta&&tb) ? niacs.testCompleteness([a,b]) :
                ta ? a : b;
    };
})
.filter('step3Completeness',function(){
    return function(context,includeUnits) {
        var objectives = niacs.collectObjectives(context,includeUnits),
            evaluated = objectives.reduce(
            function(count,objective,i,a){
                return !niacs.isEmptyObject(objective.evaluate) ? (count+1) : count;
        },0);
        return (objectives.length > 0 && evaluated == objectives.length) ? niacs.COMPLETE :
            evaluated > 0 ? niacs.PARTIAL_COMPLETE : niacs.INCOMPLETE;
    };
})
.filter('step4Banner',function(){
    return function(project) {
        var objectives = niacs.collectObjectives(project,true);
        return objectives.reduce(
            function(ids,objective,i,a){
                (objective.tactics||[]).forEach(function(t){
                    if(ids.indexOf(t.id) === -1) {
                        ids.push(t.id);
                    }
                });
                return ids;
        },[]).length +
        ' tactics apply to ' + objectives.length + ' objectives';
    };
})
.filter('step4Completeness',function(){
    return function(project) {
        var objectives = niacs.collectObjectives(project,true /* completness isn't unit specific */);
        return objectives.length === 0 ? niacs.INCOMPLETE :
            niacs.testCompleteness(objectives.map(function(e,i,a) {
                return e.tactics && e.tactics.length ? niacs.COMPLETE : niacs.INCOMPLETE;
            }));
    };
})
.filter('step5Completeness',function(){
    return function(context,includeUnits) {
        var objectives = niacs.collectObjectives(context,includeUnits),
            haveMonitoringPlans = objectives.reduce(
            function(count,objective,i,a){
                return (objective.monitor && objective.monitor.length > 0) ? (count+1) : count;
        },0);
        return (objectives.length > 0 && haveMonitoringPlans == objectives.length) ? niacs.COMPLETE :
            haveMonitoringPlans > 0 ? niacs.PARTIAL_COMPLETE : niacs.INCOMPLETE;
    };
});
